import { buildModelManager } from "../builder.js";
const DefaultQaGroupSelection = {
  __typename: true,
  id: true,
  active: true,
  createdAt: true,
  description: true,
  groupType: true,
  institution: true,
  matchConfig: true,
  memberEmails: true,
  memberUserIds: true,
  name: true,
  routingConfig: true,
  slug: true,
  updatedAt: true,
  workflowId: true
};
const modelApiIdentifier = "qaGroup";
const pluralModelApiIdentifier = "qaGroups";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaGroupSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaGroupSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaGroupSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaGroupSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaGroupSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaGroupSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaGroupSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "qaGroupGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QaGroupManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQaGroupSelection,
  operations
);
export {
  DefaultQaGroupSelection,
  QaGroupManager
};
//# sourceMappingURL=QaGroup.js.map
